import {
  CreateOrder,
  OrderMethodPayload,
  OrderMethodPayloadForContract,
  OrderType,
} from '@sdk/shared/types/order.types';
import { hashTypedData, TypedDataDomain } from 'viem';

/**
 * Create the order method object for the contract
 */
export function makeOrderMethod(
  orderMethodData: OrderMethodPayload,
): OrderMethodPayloadForContract {
  return {
    orderHash: orderMethodData.orderHash,
    method: orderMethodData.method,
    expiry: BigInt(orderMethodData.expiry),
  };
}

export function orderSigChain({
  traderChain,
  merchantChain,
  orderType,
}: {
  traderChain: number | bigint;
  merchantChain: number | bigint;
  orderType: OrderType;
}): number {
  //TODO: clarify Logic
  if (orderType == OrderType.sell) {
    return Number(traderChain);
  } else {
    return Number(merchantChain);
  }
}

/**
 * Create the typed data hash for the order method
 * Uses viem's hashTypedData utility
 */
export function createOrderMethodTypedDataHash(
  orderMethod: OrderMethodPayloadForContract,
  domain: TypedDataDomain,
): string {
  const types = {
    OrderMethod: [
      { name: 'orderHash', type: 'bytes32' },
      { name: 'method', type: 'uint8' },
      { name: 'expiry', type: 'uint256' },
    ],
  } as const;

  const message = {
    orderHash: orderMethod.orderHash,
    method: orderMethod.method,
    expiry: BigInt(orderMethod.expiry),
  };
  return hashTypedData({
    domain,
    types,
    primaryType: 'OrderMethod',
    message,
  });
}
